export default "__VITE_ASSET__CPfHonlW__"